<script setup lang="ts">
import { useSlots } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthenticatedUserStore } from "@/services/store";
import { useNavigationDrawer } from "@/modules/root/app";
import CreateWorkOrderMenu from "@/modules/workorder-details/components/CreateWorkOrderMenu.vue";
const store = useAuthenticatedUserStore();
const router = useRouter();
const { toggleNavigationDrawer } = useNavigationDrawer();

const slots = useSlots();
const route = useRoute();
</script>

<template>
  <VAppBar elevation="1" class="fixedHeight">
    <slot name="title">
      <VAppBarNavIcon @click="toggleNavigationDrawer" />
      <VAppBarTitle class="text-primary text-decoration-none font-weight-bold text-body-1 text-sm-h6">
        {{ route.meta.title }}
      </VAppBarTitle>
      <VSpacer />
      <CreateWorkOrderMenu
        v-if="
          store.isForemanOrAbove &&
          router.currentRoute.value.name !== 'create' &&
          router.currentRoute.value.name !== 'customers' &&
          router.currentRoute.value.name !== 'draft-overview' &&
          router.currentRoute.value.name !== 'zendesk'
        "
        class="mr-4"
      />
    </slot>
    <template v-if="slots.extension" #extension>
      <slot name="extension" />
    </template>
  </VAppBar>
</template>
